import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NavService, Menu } from '../../../service/nav.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public menuItems: Menu[] = [];
  public menuOpen = false;
  public isDesktop = window.innerWidth > 1008;

  constructor(
    public navServices: NavService,
    private router: Router
  ) {}

  ngOnInit() {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    this.isDesktop = window.innerWidth > 1008;
    if (this.isDesktop) {
      this.closeAllDropdowns();
      this.menuOpen = false;
    }
  }


  closeAllDropdowns() {
    this.menuItems.forEach(item => {
      item.open = false;
      item.children?.forEach(child => child.open = false);
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.isDesktop && this.menuOpen) {
      // Close all dropdowns if clicking outside menu
      this.closeAllDropdowns();
    }
  }

  isActive(path: string): boolean {
    return this.router.url === path;
  }
}
